import { SubAccountDelegationData } from '../models/sub-account-delegation-data.model';
import { LiabilityDelegationData } from '../models/liability-delegation-data.model';
import { throwError } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LiabilitiesDelegateSelectOptionType } from '../models/liabilities-delegate-select-option-type.enum';
import { LiabilitiesDelegateSelectOption } from '../models/liabilities-delegate-select-option.model';
import { CustomerBillerDelegationData } from '../models/customer-biller-delegation-data.model';

export class LiabilitiesDelegateForm extends FormGroup {
  constructor(customerBillerId: string, sources: LiabilitiesDelegateSelectOption[] = []) {
    super({
      customerBillerId: new FormControl(customerBillerId),
      sources: new FormControl(sources, [Validators.required]),
      emailAddress: new FormControl('', [Validators.email, Validators.required]),
      consent: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  get customerBillerId(): FormControl {
    return this.get('customerBillerId') as FormControl;
  }

  get sources(): FormControl {
    return this.get('sources') as FormControl;
  }

  get emailAddress(): FormControl {
    return this.get('emailAddress') as FormControl;
  }

  get consent(): FormControl {
    return this.get('consent') as FormControl;
  }

  public getSingleLiabilityFinalData(): LiabilityDelegationData {
    const source = this.sources.value[0];
    if (source !== LiabilitiesDelegateSelectOptionType.BILLER) {
      throwError('Wrong source');
    }
    return {
      customerBillerId: this.customerBillerId.value,
      liabilityId: source.id,
      delegatedEmail: { email: this.emailAddress.value },
    };
  }

  public getCustomerBillerFinalData(): CustomerBillerDelegationData {
    const source = this.sources.value[0];
    if (source !== LiabilitiesDelegateSelectOptionType.BILLER) {
      throwError('Wrong source');
    }
    return {
      customerBillerId: this.customerBillerId.value,
      delegatedEmail: { email: this.emailAddress.value },
    };
  }

  public getSubAccountFinalData(): SubAccountDelegationData {
    if (this.sources.value.includes((source) => source.type !== LiabilitiesDelegateSelectOptionType.SUBACCOUNT)) {
      throwError('Wrong source');
    }
    const subaccountIds = this.sources.value.map((source: LiabilitiesDelegateSelectOption) => source.id);

    return {
      customerBillerId: this.customerBillerId.value,
      subAccountDelegation: {
        subaccountIds,
        delegatedEmail: { email: this.emailAddress.value },
      },
    };
  }
}
